<div class="detail-container">
  <nb-card [nbSpinner]="!!(saving$|async)">
    <nb-card-header>
      <button nbButton ghost status="primary" (click)="navigateBack()">
        <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
      </button>
      <h5>Benutzer</h5>
      @if (canEdit() && !isNew()) {
        <div class="header-actions">
          <button nbButton ghost status="primary" (click)="openChangePasswordDialog()"
                  title="Passwort zurücksetzen">
            <nb-icon pack="eva" icon="lock-outline"></nb-icon>
          </button>
          <wr-edit-delete-button-group (edit)="onEdit()"
                                       (delete)="onDelete()"></wr-edit-delete-button-group>
        </div>
      }
    </nb-card-header>
    <nb-card-body>
      @if (form) {
        <form [formGroup]="form">
          <div class="sub-card-body">
            <input hidden formControlName="id">
            <div class="grid">
              <div class="col-4">
                <label class="label" for="userName">Benutzername</label>
                <input fullWidth id="userName" type="text" nbInput formControlName="userName">
                @if (hasError('userName')) {
                  <div class="error">Benutzername ist erforderlich!</div>
                }
              </div>
              <div class="col-4">
                <label class="label" for="email">Email</label>
                <input fullWidth id="email" type="text" nbInput formControlName="email">
                @if (hasError('email')) {
                  <div class="error">Email ist erforderlich!</div>
                }
              </div>
              <div class="col-4">
                <label class="label" for="abbreviation">Kürzel</label>
                <input fullWidth id="abbreviation" type="text" nbInput formControlName="abbreviation">
                @if (hasError('abbreviation')) {
                  <div class="error">Kürzel ist erforderlich!</div>
                }
              </div>
            </div>
            <div class="grid">
              <div class="col-4">
                <label class="label" for="phoneNumber">Telefon</label>
                <input fullWidth id="phoneNumber" type="text" nbInput formControlName="phoneNumber">
              </div>
              <div class="col-4">
                <label class="label" for="mobileNumber">Mobil</label>
                <input fullWidth id="mobileNumber" type="text" nbInput formControlName="mobileNumber">
              </div>
            </div>
            <div class="grid">
              <div class="col-4">
                <label class="label" for="firstName">Vorname</label>
                <input fullWidth id="firstName" type="text" nbInput formControlName="firstName">
                @if (hasError('firstName')) {
                  <div class="error">Vorname ist erforderlich!</div>
                }
              </div>
              <div class="col-4">
                <label class="label" for="lastName">Nachname</label>
                <input fullWidth id="lastName" type="text" nbInput formControlName="lastName">
                @if (hasError('lastName')) {
                  <div class="error">Nachname ist erforderlich!</div>
                }
              </div>
              <div class="col-4">
                <label class="label" for="tenantRoleSelect">Rollen</label>
                <wr-tenant-role-select id="tenantRoleSelect" formControlName="tenantRoleIds"
                                       [tenantId]="selectedTenantId()"></wr-tenant-role-select>
                @if (hasError('tenantRoleIds')) {
                  <div class="error">Rolle ist erforderlich!</div>
                }
              </div>
              @if (isAdminMode()) {
                <div class="col-4">
                  <label class="label" for="tenantSelect">Firma / Kunde oder Dienstleister</label>
                  <wr-tenant-select id="tenantSelect"
                                    formControlName="tenantId"></wr-tenant-select>
                  @if (hasError('tenantId')) {
                    <div class="error">Kunde ist erforderlich!</div>
                  }
                </div>
              }
              @if (!canEdit()) {
                <div class="col-4">
                  <label class="label" for="tenantName">Kunde/Firma</label>
                  <input fullWidth [disabled]="true" id="tenantName" type="text" nbInput formControlName="tenantName">
                </div>
              }
              @if (isAdminMode()) {
                <div class="col-4 checkbox-field">
                  <label class="label" for="enableMaintenanceNotifications">Wartungsbenachrichtigungen</label>
                  <nb-checkbox id="enableMaintenanceNotifications" formControlName="enableMaintenanceNotifications"></nb-checkbox>
                </div>
              }
            </div>
            <div class="grid">
              <div class="col-12">
                <label class="label" for="userProfilePicture">Profilbild</label>
                <wr-single-attachment-control id="userProfilePicture" formControlName="userProfilePicture"></wr-single-attachment-control>
              </div>
            </div>
          </div>
        </form>
      }
      @if (showQrPin(); as user) {
        <wr-user-qr-pin [userId]="user.id" [hasQrPin]="user.hasQrPin"
                        [qrPinCreated]="user.qrPinCreated"></wr-user-qr-pin>
      }
    </nb-card-body>
    @if (canEdit()) {
      <nb-card-footer>
        @if (isNew() && currentUserLoadFailed() && !selectedTenantId()) {
          <wr-banner [icon]="{ icon: 'alert-triangle-outline', pack: 'eva' }"
                     status="warning"
                     message="Die eigene Firma konnte nicht geladen werden — die Rollenauswahl bleibt deshalb leer. Bitte die Seite neu laden.">
          </wr-banner>
        }
        <button size="medium" [disabled]="!isEditing || (isNew() && !selectedTenantId())" nbButton status="primary" (click)="submit()">Speichern</button>
        <button size="medium" [disabled]="!isEditing" nbButton status="basic" (click)="cancel()">Zurück</button>
      </nb-card-footer>
    }
  </nb-card>
</div>
